/* Angular modules */
import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit, SimpleChange,
  SimpleChanges
} from '@angular/core';
/* ngx modules */
import {SessionStorage} from 'ngx-webstorage';
import {LoggerService} from '../../shared/logging/logger.service';
/* app modules*/
import {ComponentType} from '../shared/model/component-type';
import {ComponentSearchModeEnum, SwitchBoardComponent} from '../shared/model/component';
import {ComponentService} from '../shared/services/component.service';
import {Item} from '../../project/shared/project-model';
import {AddingTransformerInfosWrapper} from '../shared/model/AddingTransformerInfosWrapper';
import {FilterCategory} from '../shared/model/filterCategory';
import {ProductsFiltersService} from '../../shared/products-filters/products-filters.service';
import {VisibilityCheck} from '../shared/model/visibilityCheck';
import {TransformerService} from '../../transformer/shared/transformer-service';
import {RangeType} from '../../shared/model/range-type';
import {User} from '../../shared/user/user';
import {isNullOrUndefined} from 'util';
import {MySEStatusEnum} from '../../shared/model/mySEStatusEnum';
import {FilterService} from '../shared/services/filter.service';
import {PriceManagementService} from '../../admin/shared';
import * as _ from 'lodash';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-selection',
  templateUrl: './selection.component.html',
  styleUrls: ['./selection.component.less']
})
export class SelectionComponent implements OnInit, OnChanges, AfterViewChecked, OnDestroy {
  @Input()
  componentType: ComponentType;

  @Input()
  transformerInfos: AddingTransformerInfosWrapper;

  @SessionStorage()
  currentItemct: Item;

  @SessionStorage()
  user: User;

  allComponents: SwitchBoardComponent[];

  filteredComponents: SwitchBoardComponent[];


  rangeComponents: Array<SwitchBoardComponent>;
  displayedComponents: Array<SwitchBoardComponent>;

  filters: Array<FilterCategory> = [];
  resetFilters = false;

  loading = false;
  loadingTransformers = false;

  unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private logger: LoggerService,
              private componentService: ComponentService,
              private productsFiltersService: ProductsFiltersService,
              private cdRef: ChangeDetectorRef,
              private transformerService: TransformerService,
              private priceManagementService: PriceManagementService,
              private filterService: FilterService) {
  }

  ngOnInit() {
    // If user arrive directly from the project page we need to reload the components and re-apply electrical characteristics filters if any
    if (!this.allComponents || this.allComponents.length === 0) {
      this.loading = true;

      // Get all components of ranges from backend
      this.componentService.getComponents(this.currentItemct.id, ComponentSearchModeEnum.ALL)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(result => {
          this.allComponents = result;
          // No electrical characteristics screen so no pre filter of components
          this.rangeComponents = this.allComponents.filter(component => {
            if (this.currentItemct.range.rangeType === RangeType.SWITCHBOARD || this.currentItemct.range.rangeType === RangeType.BUDJETARY_QUOTE) {
              return component.type === ComponentType.CUBICLE;
            }
            return component.type === ComponentType.TRANSFORMER;
          });
          if (this.currentItemct.range.hideCharacteristicScreen) {
            this.filteredComponents = this.rangeComponents;
            this.displayedComponents = this.rangeComponents;
          } else {
            // Electrical characteristics screen so application of electrical filter
            const electricalFilters = this.productsFiltersService.extractFiltersFromComponents(this.rangeComponents,
              this.currentItemct.range.electricalCharacteristicsFilters, true, new Map<string, VisibilityCheck>());
            // Apply previous selection to filters
            this.productsFiltersService.selectElectricalCharacteristicsFilter(this.currentItemct.electricalCharacteristics, electricalFilters);
            // Apply filters
            this.filteredComponents = <SwitchBoardComponent[]>this.productsFiltersService.applyFilters(electricalFilters, this.rangeComponents);
            this.rangeComponents = this.filteredComponents;
            this.displayedComponents = this.filteredComponents;
          }
          this.afterComponentsLoading();
          this.loading = false;
        });
    } else if (this.currentItemct.range.rangeType === RangeType.SWITCHBOARD) {
      // Adding only the transformers compatible to the range
      this.loadingTransformers = true;
      this.componentService.getComponents(this.currentItemct.id, ComponentSearchModeEnum.COMPATIBLE)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(result => {
          this.allComponents.push(...result);
          this.allComponents = _.uniqBy(this.allComponents, comp => comp.id);
          this.loadingTransformers = false;
          if (this.componentType === ComponentType.TRANSFORMER) {
            this.displaySelectionForTransformers();
          }
        });
    }
  }

  /**
   * FIXME: ngOnChanges is not used correctly here. I don't want to change the code too much and do
   * the required code refactoring to fix DYN-6711.
   */
  ngOnChanges(changes: SimpleChanges) {

    this.resetFilters = changes.componentType ? changes.componentType.currentValue !== changes.componentType.previousValue : false;

    this.loading = true;

    if (this.allComponents) {
      this.afterComponentsLoading(changes.componentType);
    }
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    // unsubscribe from the subject itself:
    this.unsubscribe$.unsubscribe();
  }

  public updateComponentList(selectedFilters: Array<FilterCategory>) {
    this.filters = selectedFilters;
    this.displayedComponents = <SwitchBoardComponent[]>this.productsFiltersService.applyFilters(selectedFilters, this.rangeComponents);
    this.productsFiltersService.updateFilters(this.filters, this.displayedComponents);
  }

  /**
   * removes all filters and displays initial components
   */
  public removeAllFilters() {
    this.displayedComponents = this.rangeComponents;
    if (this.currentItemct.range.rangeType === RangeType.SWITCHBOARD && this.componentType === ComponentType.TRANSFORMER) {
      this.transformerService.getFiltersForAllRanges()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(visibleFilters => {
          this.extractFilterAddingTransformer(visibleFilters);
        });
    } else {
      this.filters = this.productsFiltersService.extractFiltersFromComponents(this.rangeComponents,
        this.currentItemct.range.visibleComponentsFilters, false, new Map<string, VisibilityCheck>());

      // Specific sort order for filters
      this.filterService.sortFiltersRegardingRange(this.filters, this.currentItemct.range);
    }
  }
  private afterComponentsLoading (componentType?: SimpleChange){

    this.rangeComponents = this.filteredComponents.filter(component => component.type === this.componentType);
    // In the case of 'cross selling' filter only compatible transformers reference
    if (this.componentType === ComponentType.TRANSFORMER && this.transformerInfos
      && this.transformerInfos.compatibleTransformerList && this.transformerInfos.compatibleTransformerList.length > 0) {
      this.allComponents = this.allComponents.filter(comp => this.transformerInfos.compatibleTransformerList.includes(comp.reference.ref));
    }
    this.sortComponents();

    // When adding a transformer to a cubicle we must retrieve the visible filters of all the transformer ranges
    if (this.currentItemct.range.rangeType === RangeType.SWITCHBOARD && this.componentType === ComponentType.TRANSFORMER) {
      if (componentType === undefined) {
        // If componentType had not changed, it means we have click on Add transformer 2 times in a row
        this.filters = [];
      }
      this.displaySelectionForTransformers();
    } else {
      // Normal case adding a component for cubicle range or transformer range
      this.filters = this.productsFiltersService.extractFiltersFromComponents(this.rangeComponents,
        this.currentItemct.range.visibleComponentsFilters, false, new Map<string, VisibilityCheck>());
      // Specific sort order for filters
      this.filterService.sortFiltersRegardingRange(this.filters, this.currentItemct.range);

      this.displayedComponents = <SwitchBoardComponent[]>this.productsFiltersService.applyFilters(this.filters, this.rangeComponents);
      this.loading = false;
    }
  };

  private extractFilterAddingTransformer(visibleFilters) {
    let initFilter = true;
    const componentsGroupByRange = _.groupBy(this.rangeComponents, comp => comp.rangeId);
    for (const key of Object.keys(componentsGroupByRange)) {
      this.transformerService.getRange(key)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(range => {
          // Flag to avoid latency on display
          if (initFilter) {
            this.filters = [];
            initFilter = false;
          }
          const filters: FilterCategory[] = this.productsFiltersService.extractFiltersWithCubicleIncompatibilities(componentsGroupByRange[key], visibleFilters, false,
            (this.transformerInfos === undefined || this.transformerInfos === null) ? null : this.currentItemct.components[this.transformerInfos.cubicleNumber],
            new Map<string, VisibilityCheck>());
          filters.forEach(filter => {
            filter.rangeName = range.nameKey;
          });
          this.filters = this.filters.concat(filters);
        });
    }
  }

  /**
   * Sort components according to the range defined criterion (default sort by reference)
   * When sorting all transformer ranges of the offer for add to a cubicle retrieving from server
   */
  private sortComponents() {
    if (this.currentItemct.range.rangeType === RangeType.SWITCHBOARD && this.componentType === ComponentType.TRANSFORMER) {
      this.transformerService.getCardSortCriterionForAllRanges()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(criterion => this.filterService.doTheSort(criterion, this.rangeComponents));
    } else {
      this.filterService.doTheSort(this.currentItemct.range.cardSortCriterion, this.rangeComponents);
    }
  }

  /**
   * Display transformer for adding on switchboard
   */
  private displaySelectionForTransformers() {
    this.rangeComponents = this.allComponents.filter(component => component.type === ComponentType.TRANSFORMER);
    // Filters computing
    this.transformerService.getFiltersForAllRanges()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(visibleFilters => {
        this.extractFilterAddingTransformer(visibleFilters);
        this.displayedComponents = <SwitchBoardComponent[]>this.productsFiltersService.applyFilters(this.filters, this.rangeComponents);
        this.loading = false;
      });
  }
}
